import Vue from "vue";
import axios from "./axios";
import http from "./http";
import drag from "./directive/el-dialog-drag";
import rule from "@/util/rule";
import bus from "./bus";
import auth from "../util/loginUtil";
import {Message} from "element-ui";

Plugin.install = function(Vue) {
  Vue.directive("el-drag-dialog", drag);
  //event bus
  Vue.prototype.$bus = bus;
  // 网络请求
  Vue.prototype.$axios = axios;
  Vue.prototype.$rule = rule;
  Vue.prototype.$http = http;
  //重置表单
  Vue.prototype.$reset = function(formRef, ...excludeFields) {
    if (formRef) {
      this.$refs[formRef].resetFields();
    }
    let obj1 = this.$data;
    let obj2 = this.$options.data.call(this);
    if (!excludeFields || excludeFields.length === 0) {
      excludeFields = ["ruleValidate"];
    }
    for (let attrName in obj1) {
      if (excludeFields && excludeFields.includes(attrName)) {
        continue;
      }
      obj1[attrName] = obj2[attrName];
    }
  };
  //全局异常处理
  Vue.config.errorHandler = function(err, vm, info) {
    console.error(err, vm, info);
    Message.error(err);
  };
  //权限判断
  Vue.prototype.$auth = function(authIndex) {
    //console.log("auth", authIndex);
    if(auth.getUserName()==="admin") {
      return true;
    }
    if(authIndex===0 && auth.getUserType() !== 2) {
      return true;
    }
    let permissions = auth.getAuthString();
    //console.log(permissions);
    return permissions && permissions.charAt(authIndex) === "1";
  };
};
Vue.use(Plugin);

export default Plugin;
